import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-remove-icon',
    templateUrl: './remove-icon.component.html',
    styleUrls: ['./remove-icon.component.scss']
})
export class RemoveIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 24;
        this.width = 24;
    }
}

